import { EXPLORE_FILTER_CATEGORY } from './use-experience-filter';
import useSetFilter, { CategoryKey } from './use-set-filter';

const useSetCategory = () => useSetFilter<CategoryKey | undefined>(EXPLORE_FILTER_CATEGORY);

export default useSetCategory;
